// get no save materials (sliders) from local storage
export const getEditIdElements = (): number[] =>
{
    const search = 'no-save';
    const cut = 8; // no-save-;
    const values = Object.keys(localStorage).filter(key => key.startsWith(search));

    if (values)
    {
        const ids = [];

        for (let i = 0; i < values.length; i++)
        {
            ids.push(Number(values[i].slice(cut)));
        }

        return ids;
    }

    return [];
};
